import React from "react";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import { Form } from "react-final-form";
import { Dialog } from "@syos-music/common";

import { Alert, Button, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const MUTATION = gql`
  mutation ($discountCodeId: ID!) {
    DeleteDiscountCode(discountCodeId: $discountCodeId) {
      status
    }
  }
`;

export default function DeleteDiscountCode({
  discountCode,
  onDeleted,
  children,
}) {
  const [isOpen, setIsOpen] = React.useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const [deleteDiscountCode] = useMutation(MUTATION);

  return (
    <>
      {children({ isOpen, open, close })}

      <Dialog open={isOpen} onClose={close}>
        <Form
          onSubmit={() =>
            deleteDiscountCode({
              variables: { discountCodeId: discountCode.id },
            })
              .then(() => {
                close();
                onDeleted();
              })
              .catch(() => true)
          }
          keepDirtyOnReinitialize
        >
          {({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
              <Dialog.Title color="primary">
                Supprimer un code de réduction
              </Dialog.Title>

              <Dialog.Content>
                <Alert severity="warning">
                  <Typography color="inherit">
                    Voulez-vous vraiment supprimer le code de réduction{" "}
                    <code>{discountCode.code}</code> ?
                  </Typography>
                </Alert>
              </Dialog.Content>

              <Dialog.Actions>
                <Button variant="text" onClick={close}>
                  Annuler
                </Button>

                <LoadingButton type="submit" loading={submitting}>
                  Supprimer
                </LoadingButton>
              </Dialog.Actions>
            </form>
          )}
        </Form>
      </Dialog>
    </>
  );
}

DeleteDiscountCode.defaultProps = {
  onDeleted: () => {},
};

DeleteDiscountCode.fragments = {
  discountCode: gql`
    fragment DeleteDiscountCode_discountCode on DiscountCode {
      id
      code
    }
  `,
};
